import { Button, Col, Form, Input, Row } from 'antd';
import { useContext } from 'react';
import { NotificationContext } from '../../providers/NotificationProvider';
import { useDispatch } from 'react-redux';
import { recoverPassword } from '../../features/user/userSlice'; // Agrega esta acción en tu Redux slice
import logo from '../../assets/images/logo.png';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageTabs from '../shared/LanguageTabs';
import { useTurnstileCaptcha } from './useTurnstileCaptcha';
type FieldType = {
  email?: string;
};

const RecoveryPassword: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { triggerNotification } = useContext(NotificationContext);
  const { captchaRef, captchaToken, captchaReady, resetCaptcha, turnstileSiteKey } = useTurnstileCaptcha();

  const handleSubmit = (values: any) => {
    if (!turnstileSiteKey) {
      triggerNotification('error', t('Error'), t('El captcha no está configurado.'), 'bottomRight');
      return;
    }

    if (!captchaToken) {
      triggerNotification('error', t('Error'), t('Por favor valida el captcha.'), 'bottomRight');
      return;
    }

    dispatch(recoverPassword({ email: values.email as string, captcha_token: captchaToken }) as any)
      .then((response: any) => {
        if (recoverPassword.fulfilled.match(response)) {
          resetCaptcha();
          triggerNotification(
            'success',
            t('Éxito'),
            t('Te hemos enviado un correo electrónico para restablecer tu contraseña'),
            'bottomRight'
          );
        } else {
          resetCaptcha();
          triggerNotification('error', t('Error'), response.message, 'bottomRight');
        }
      })
      .catch((err: any) => {
        resetCaptcha();
        triggerNotification('error', t('Error'), err.message, 'bottomRight');
      });
  };

  return (
    <div className='home-login'>
      <div style={{ position: 'absolute', top: 16, right: 16 }}>
        <LanguageTabs compact />
      </div>
      <Row>
        <Col className='form-login-container'>
          <img src={logo} alt='logo' className='logo' />
          <Form name='recovery' style={{ maxWidth: 600 }} onFinish={handleSubmit} autoComplete='off'>
            <Form.Item<FieldType>
              label={t('Correo electrónico')}
              name='email'
              rules={[{ required: true, message: t('Por favor ingresa tu correo electrónico.') }]}
            >
              <Input />
            </Form.Item>
            <small>
              {t('Al llenar este formulario estás aceptando las políticas de')}
              <br /> tratamiento de la información que puedes consultar{' '}
              <a target='_blank' href='https://cstrisk.com/privacy-policy/' rel='noreferrer'>
                {t('aquí')}
              </a>
            </small>
            <br />
            <br />
            <div className='trial-captcha-wrapper'>
              {turnstileSiteKey ? (
                <div ref={captchaRef} />
              ) : (
                <small>{t('Configura REACT_APP_TURNSTILE_SITE_KEY para habilitar el captcha.')}</small>
              )}
            </div>
            <Form.Item>
              <Button type='primary' htmlType='submit' disabled={!captchaReady && !!turnstileSiteKey}>
                {t('Recuperar contraseña')}
              </Button>
            </Form.Item>
            <Form.Item>
              <Button
                type='default'
                htmlType='button'
                onClick={() => {
                  navigate('/');
                }}
              >
                {t('Volver')}
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default RecoveryPassword;
